import Gumshoe from 'gumshoejs';

class Scrollspy {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        
        const spy = new Gumshoe('[data-nav-link]', {
            navClass: 'is-active',
            offset: function () {
                return self.elem.getBoundingClientRect().height;
            }
        });
    }
}

export default Scrollspy;
